export default __webpack_public_path__ + "static/media/budgetTracking.d48d1085.svg";